import { render, staticRenderFns } from "./VisitDetail.vue?vue&type=template&id=37fe3aab&"
import script from "./VisitDetail.ts?vue&type=script&lang=ts&"
export * from "./VisitDetail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports